import { useLayoutEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { showNavState } from '@atom/setting/navigation';

/**
 * Nav 표시/숨기기 훅.
 * layoutType은 건드리지 않고 showNavState만 토글하여
 * NavWrapper를 CSS display:none으로 숨기는 방식으로 동작합니다.
 * 언마운트 시 자동으로 showNav=true 복원.
 */
function showNav(status: boolean) {
  const setShowNav = useSetRecoilState(showNavState);

  useLayoutEffect(() => {
    setShowNav(status);
    return () => {
      setShowNav(true);
    };
  }, [status, setShowNav]);
}

export default showNav;
